(function () {
  'use strict';

  class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.sticky-atc__btn');
      this.quantityInput = this.querySelector('.sticky-atc__qty-input');
      this.productInfo = document.querySelector("product-info[id^='MainProduct-']");
      this.productForm =
        this.productInfo?.querySelector('product-form') || document.querySelector('product-form');
      this.form = this.productForm?.querySelector('form') || document.querySelector('form[action*="/cart/add"]');
      this.mainQuantityInput =
        this.productInfo?.querySelector('[name="quantity"]') || this.form?.querySelector('[name="quantity"]');
      this.trigger = this.productForm || this.form;
      this.setAttribute('aria-hidden', 'true');

      this.syncFromMain = this.syncFromMain.bind(this);
      this.syncToMain = this.syncToMain.bind(this);
      this.handleQuantityChange = this.handleQuantityChange.bind(this);

      if (this.quantityInput) {
        this.syncFromMain();
        this.quantityInput.addEventListener('input', this.handleQuantityChange);
        this.quantityInput.addEventListener('change', this.handleQuantityChange);
      }

      if (this.mainQuantityInput) {
        this.mainQuantityInput.addEventListener('input', this.syncFromMain);
        this.mainQuantityInput.addEventListener('change', this.syncFromMain);
      }

      this.querySelectorAll('[data-qty-step]').forEach((control) => {
        control.addEventListener('click', () => {
          if (!this.quantityInput) return;
          const direction = Number(control.dataset.qtyStep) || 0;
          const step = Number(this.quantityInput.step) || 1;
          const current = Number(this.quantityInput.value) || Number(this.quantityInput.min) || 1;
          this.quantityInput.value = this.normalizeQuantity(current + direction * step);
          this.syncToMain();
        });
      });

      this.button?.addEventListener('click', () => this.proxyAdd());

      requestAnimationFrame(() => this.classList.add('is-ready'));

      if (!this.trigger || !('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(
        ([entry]) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('is-active', scrolledPast);
          this.setAttribute('aria-hidden', String(!scrolledPast));
        },
        { threshold: 0 }
      );
      this.observer.observe(this.trigger);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.quantityInput?.removeEventListener('input', this.handleQuantityChange);
      this.quantityInput?.removeEventListener('change', this.handleQuantityChange);
      this.mainQuantityInput?.removeEventListener('input', this.syncFromMain);
      this.mainQuantityInput?.removeEventListener('change', this.syncFromMain);
    }

    normalizeQuantity(value) {
      const min = Number(this.quantityInput?.min) || 1;
      const max = Number(this.quantityInput?.max) || Number.POSITIVE_INFINITY;
      const step = Number(this.quantityInput?.step) || 1;
      const stepped = min + Math.round((Math.max(min, value) - min) / step) * step;
      return Math.min(max, stepped);
    }

    handleQuantityChange() {
      if (!this.quantityInput) return;
      this.quantityInput.value = this.normalizeQuantity(Number(this.quantityInput.value) || 1);
      this.syncToMain();
    }

    syncFromMain() {
      if (!this.quantityInput || !this.mainQuantityInput) return;
      this.quantityInput.value = this.normalizeQuantity(Number(this.mainQuantityInput.value) || 1);
    }

    syncToMain() {
      if (!this.quantityInput || !this.mainQuantityInput) return;
      this.mainQuantityInput.value = this.quantityInput.value;
      this.mainQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      this.mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    proxyAdd() {
      if (!this.form) return;
      this.syncToMain();
      const addButton = this.form.querySelector('[type="submit"], [name="add"]');
      if (addButton) {
        addButton.click();
      } else {
        this.form.requestSubmit?.();
      }
    }
  }

  if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyAtc);
})();
